import React from "react";
import useThemeColors from "../../vehicle/ThemeColors";

interface IPROPS {
  closeModal: any;
  refetch: any;
  storeValue: any;
  triggerDeleteService: any;
}

const DeleteServiceMaster: React.FC<IPROPS> = ({
  closeModal,
  refetch,
  storeValue,
  triggerDeleteService,
}) => {
  console.log(storeValue, "storevalueue");

  const deleteFieldHandler = async (e) => {
    e.preventDefault();

    const deletePayload = {
      id: storeValue?.id,
    };

    const response = await triggerDeleteService(deletePayload);
    closeModal();
    refetch();
  };

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
      }}
    >
      {/* <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={() => closeModal(true)}
        ></i>
      </div> */}
      <div
        style={{
          color: "#3071e4",
          fontSize: "18px",
          fontWeight: 200,
          fontFamily: "karbon",
        }}
      >
        Are you sure?
      </div>
      <div
        style={{
          marginBottom: "15px",
          fontSize: "16px",
          fontWeight: 200,
          fontFamily: "karbon",
          color: "#666666",
        }}
      >
        Do you really want to delete these records? This process cannot be
        undone.
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <button
          onClick={deleteFieldHandler}
          style={{
            background: `${selectedButtonBackgoundColors}`,
            color: `${selectedButtonColors}`,
            border: "none",
            padding: "10px 20px",
            borderRadius: "20px",
            fontSize: "15px",
            fontWeight: 200,
            fontFamily: "karbon",
          }}
        >
          Delete
        </button>
        <button
          className="btn btn-light"
          style={{ fontSize: "15px", fontWeight: 200, fontFamily: "karbon" }}
          onClick={() => closeModal(true)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteServiceMaster;
